<template>
  <div class="h-full w-full p-10px bg-[#fff]">
    <div class="mb-10px">
      <el-input
        class="mr-10px !w-250px"
        clearable
        v-model="keyWords"
        size="small"
        placeholder="请输入桥架名称"
      ></el-input>

      <el-button class="mr-10px" size="small" type="primary" @click="searchList"> 搜索</el-button>
      <el-button class="mr-10px" size="small" type="primary" @click="resetSearch"> 重置</el-button>
      <el-button class="mr-10px" size="small" type="primary" @click="createCable"> 新增</el-button>

      <el-button type="danger" size="small" @click="deleteAny" class="mr-10px"> 删除</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      height="calc(100% - 100px)"
      stripe
      v-loading="loading"
      ref="tableRef"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="index" label="序号" :width="60"></el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :fixed="item.fixed || false"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" align="left" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
        </template></el-table-column
      >
    </el-table>
    <div class="text-right mt-10px">
      <el-pagination
        background
        @size-change="getList()"
        @current-change="getList()"
        :current-page.sync="page.no"
        :page-size.sync="page.size"
        :page-sizes="[10, 15, 20, 30, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>

import { CableTrayApi } from '@wiz-api/tongre'

const cableTrayApi = new CableTrayApi()
export default {
  components: {},
  data() {
    return {
      keyWords: '',
      checkList: [],
      columns: [
        { prop: 'name', label: '桥架名称' },
        { prop: 'code', label: '桥架编码' },
        { prop: 'createTime', label: '创建日期', width: 180 },
        { prop: 'userName', label: '创建人员', width: 180 },
      ],
      loading: true,
      tableData: [],
      page: {
        no: 1,
        size: 20,
        total: 0,
      },
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
    userId() {
      // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      return sub
    },
  },
  methods: {
    async getList() {
      this.loading = true
      const [er, res] = await cableTrayApi.getCableTrayPagedList({
        body: {
          keyWords: this.keyWords,
          skipCount: (this.page.no - 1) * this.page.size,
          maxResultCount: this.page.size,
          loginUserId: this.userId
        },
      })
      if (!er) {
        this.tableData = res.items
      }
      this.loading = false
    },
    resetSearch() {
      this.keyWords = ''
      this.tableData = []
      this.page.no = 1
      this.getList()
    },
    searchList() {
      this.page.no = 1
      this.tableData = []
      this.getList()
    },
    changePlan(val) {
      this.currentPlan = val
    },
    async deleteItem(row) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {
        const [er, res] = await cableTrayApi.batchDeleteCableTray({ body: [row.id] })
        if (!er) {
          this.$message.success('操作成功！')
          this.searchList()
        }
      })
    },

    createCable() {
      this.$router.push({
        path: `${this.basePath}/cable-tray-vulkan/create-cable`,
      })
    },
    closeDialog() {},

    handleSelectionChange(val) {
      this.checkList = val.map((o) => {
        return o.id
      })
    },
    // eslint-disable-next-line consistent-return
    deleteAny() {
      if (this.checkList.length === 0) return this.$message.warning('至少选择一条数据！')
      this.$confirm('是否删除选中数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {
        const [er, res] = await cableTrayApi.batchDeleteCableTray({ body: this.checkList })
        if (!er) {
          this.$message.success('操作成功！')
          this.searchList()
        }
      })
    },
  },
  mounted() {
    this.getList()
  },
  activated() {
    this.getList()
  },
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.h-full {
  height: 100%;
}
.w-full {
  width: 100%;
}
.p-10px {
  padding: 10px;
}
.bg-\[\#fff\] {
  background: #fff;
}
.\!w-150px {
  width: 150px !important;
}
.mr-10px {
  margin-right: 10px;
}
.mb-10px {
  margin-bottom: 10px;
}
.mt-10px {
  margin-top: 10px;
}
</style>
